import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CoreLogService } from '../../services/log.service';
import Utils from '../../shared/utils';

@Component({
  selector: 'ya-customcalendar',
  templateUrl: './customCalendar.component.html',
  styleUrls: ['./customCalendar.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR, useExisting: CustomCalendarComponent, multi: true
  }]
})
export class CustomCalendarComponent implements OnInit, ControlValueAccessor {

  private dateValue: number;
  @Input() calenderIsRequired: boolean = false;
  @Input() label: string = '';
  @Output() dateNotValid = new EventEmitter<boolean>();

  public birthDateYYYY: string = "";
  public birthDateMM: string = "";
  public birthDateDD: string = "";
  public hasValue: boolean = false;

  @ViewChild("CustomCalendarInput", { read: ElementRef }) inputElementRef: ElementRef;

  constructor(private _coreLogService: CoreLogService
    , private _renderer: Renderer2) { }

  onTouched = () => { };
  onChange = (newValue: any) => { };

  writeValue(obj: any): void {
    const me = this;
    me.dateValue = obj;
    me.showDateFromnumber();
  }

  registerOnTouched(fn: any) {
    const me = this;
    me.onTouched = fn;
  }

  registerOnChange(fn: any) {
    const me = this;
    me.onChange = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    const me = this;
    me._renderer.setProperty(this.inputElementRef.nativeElement, 'disabled', isDisabled);
  }


  // ngOnChanges(changes: SimpleChanges): void {
  //   const me = this;
  //   if (changes.date && !changes.date.firstChange) {
  //     me.showDateFromnumber();
  //   }
  // }

  ngOnInit() {
    const me = this;
    //me.showDateFromnumber();
  }

  /**get number as date and seperate year month and day to show in inputs calendar */
  private showDateFromnumber() {
    const me = this;
    if (me.dateValue > 0) {
      me.birthDateYYYY = Utils.padLeft(Math.trunc(me.dateValue / 10000) % 10000, 2);
      me.birthDateMM = Utils.padLeft(Math.trunc(me.dateValue / 100) % 100, 2);
      me.birthDateDD = Utils.padLeft(Math.trunc(me.dateValue) % 100, 2);
      me.onChange(me.dateValue);
      me.hasValue = true;
    } else {
      me.birthDateYYYY = "";
      me.birthDateMM = "";
      me.birthDateDD = "";
      me.onChange(null);
      me.hasValue = false;
    }
  }

  // to check if Date is correct; the date that user entered must br a real date z.B 50.50.1999 is not validate
  @HostListener("focusout", ["$event"])
  public validateDate() {
    const me = this;
    if (me.birthDateYYYY === "" && me.birthDateMM === "" && me.birthDateDD === "") {
      me.dateNotValid.emit(false);
    } else if (Utils.isValidateDate(+me.birthDateYYYY, +me.birthDateMM - 1, +me.birthDateDD)) {
      me.dateNotValid.emit(false);
    } else {
      me.dateNotValid.emit(true);
    }
  }

  // set date base on value on inputs
  public setDate() {
    const me = this;
    if (me.birthDateYYYY === "" && me.birthDateMM === "" && me.birthDateDD === "") {
      me.onChange(null);
      me.hasValue = false;
    } else {
      me.dateValue = (+me.birthDateYYYY * 10000) + (+me.birthDateMM * 100) + (+me.birthDateDD * 1);
      me.onChange(me.dateValue);
      me.hasValue = true;
    }
  }

  /**set focus to next input in birthdate inputs */
  public onKeyUpDateInput(event) {
    const me = this;
    if (event.id === "birthdateDD") {
      me.birthDateDD = event.value;
    } else if (event.id === "birthdateMM") {
      me.birthDateMM = event.value;
    } else {
      me.birthDateYYYY = event.value;
    }
    me.setDate();
    me.checkHasValue();
  }

  private checkHasValue() {
    const me = this;
    me.hasValue = me.birthDateDD !== "" || me.birthDateMM !== "" || me.birthDateYYYY !== "";
  }

}
